import { render } from "./signup-page.vue?vue&type=template&id=3f5ff2d0&scoped=true"
import script from "./signup-page.vue?vue&type=script&lang=js"
export * from "./signup-page.vue?vue&type=script&lang=js"

import "./signup-page.vue?vue&type=style&index=0&id=3f5ff2d0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f5ff2d0"]])

export default __exports__